/**
 * Module-scoped bridge for communication between React components
 * and bpmn-js custom modules (plain JS / Preact).
 *
 * Replaces globalThis.__openLightbox and globalThis.__bpmnEventBus
 * to avoid exposing attack surface on the global window object.
 */

let _openLightbox = null;
let _bpmnEventBus = null;

export function setOpenLightbox(fn) {
  _openLightbox = fn;
}

export function getOpenLightbox() {
  return _openLightbox;
}

export function setBpmnEventBus(eventBus) {
  _bpmnEventBus = eventBus;
}

export function getBpmnEventBus() {
  return _bpmnEventBus;
}

let _openLinkModal = null;

export function setOpenLinkModal(fn) {
  _openLinkModal = fn;
}

export function getOpenLinkModal() {
  return _openLinkModal;
}
